import * as React from 'react';


export default class Clone extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <path d="M11.9861368,0.368347368 L2.50445263,0.368347368 C2.31655789,0.368347368 2.16403158,0.520873684 2.16403158,0.708768421 L2.16403158,2.30255789 L10.1897158,2.30255789 C10.3783474,2.30255789 10.5301368,2.45508421 10.5301368,2.64297895 L10.5301368,11.8203474 L11.9861368,11.8203474 C12.1747684,11.8203474 12.3265579,11.6678211 12.3265579,11.4799263 L12.3265579,0.708768421 C12.3265579,0.520873684 12.1747684,0.368347368 11.9861368,0.368347368 Z" id="Stroke-1"></path>
        <path d="M2.16432632,2.30255789 L0.708326316,2.30255789 C0.521168421,2.30255789 0.367905263,2.45508421 0.367905263,2.64297895 L0.367905263,13.4141368 C0.367905263,13.6020316 0.521168421,13.7545579 0.708326316,13.7545579 L10.1900105,13.7545579 C10.3786421,13.7545579 10.5304316,13.6020316 10.5304316,13.4141368 L10.5304316,11.8203474" id="Stroke-3"></path>
      </svg>
    )
  }
}
